import { render, staticRenderFns } from "./DeliveryMethod.vue?vue&type=template&id=2b66968c&scoped=true&"
import script from "./DeliveryMethod.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethod.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryMethod.vue?vue&type=style&index=0&id=2b66968c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66968c",
  null
  
)

export default component.exports